import script from "./ContactUs.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUs.vue?vue&type=script&setup=true&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=739bc28c&lang=css"

const __exports__ = script;

export default __exports__